/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import BarraPc from "./BarraPc";
import BarraCel from "./BarraCel";

const Barra = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            size={12}
        >

            {sCell ?
                <BarraCel/>
                :
                <BarraPc/>
            }


        </Grid>
    )

}
export default Barra